import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonFunctions } from '@shared/common-functions';
import { EMAIL_VALIDATION_PATTERN, MULTILINGUAL_NAME_VALIDATION_PATTERN, USER_ROLES } from '@shared/constant/shared.constant';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SuperAdminService } from '@core/services/super-admin.service';
import { DriverCreatedSucessComponent } from '../driver-created-sucess/driver-created-sucess.component';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { ConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-user-create-modal',
  templateUrl: './user-create-modal.component.html',
  styleUrls: ['./user-create-modal.component.scss']
})
export class UserCreateModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  selectedOption: string = 'parker';
  showInput : boolean = false;
  initiateBooking: FormGroup;
  options = [
    { value: 'parker', label: 'Create  Parker', icon: 'assets/images/parker-icon.svg', hoverIcon: 'assets/images/parkar-line-hover.svg' },
    { value: 'groupUser', label: 'Create Group Operator', icon: 'assets/images/group-icon.svg', hoverIcon: 'assets/images/group-hover-icon.svg' }
  ];
  customErrorMsg: string;
  userRoles = USER_ROLES;
  role: string;
  createUserForm: FormGroup;
  nationalNumber: PhoneNumberFormat;
  searchCountryField = SearchCountryField;
  countryISO: CountryISO = CountryISO.UnitedStates;
  phoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  separateDialCode = false;
  toolTipInfo : string = 'An email or mobile number is required.'
  accountErrorMsg: string = '';
  requiredLastNameAsterisk: boolean = false;
  constructor(
    private readonly fb: FormBuilder,
    private readonly ref: DynamicDialogRef,
    private readonly superAdminService: SuperAdminService,
    private readonly dialogControlService: DialogControlService,
    private readonly encryptStorage: EncryptionStorageService,
    private readonly configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.role = this.encryptStorage.getItem('roleName');
    this.initialiseCreateUserForm();
    this.selectOption('parker');
  }
  initialiseCreateUserForm(): void {
    this.createUserForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3), Validators.maxLength(50), CommonFunctions.noLeadingSpacesValidator()]],
      lastName: ['', [Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN),Validators.minLength(3), Validators.maxLength(50), CommonFunctions.noLeadingSpacesValidator()]],
      email: ['', [Validators.required, Validators.pattern(EMAIL_VALIDATION_PATTERN)]],
      phone: ['',[Validators.required]],
      groupName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
    });
  }

  selectOption(option: string): void {
    this.selectedOption = option;
    this.updateCompanyNameValidation();
    this.islastNameRequired(option);
    this.accountErrorMsg = '';
    this.createUserForm.reset();
    this.showInput = option === 'groupUser';
  }

  islastNameRequired(selectedOption: string): void {
    const lastNameControl = this.createUserForm.get('lastName');
    const { validators, required } = CommonFunctions.getLastNameValidators(selectedOption === 'groupUser' ? 'groupOperator' : 'driver', this.configService);
    this.requiredLastNameAsterisk = required;
    lastNameControl.setValidators([...validators, Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3), Validators.maxLength(50), CommonFunctions.noLeadingSpacesValidator()]);
  }

  updateCompanyNameValidation(): void {
    const companyNameControl = this.createUserForm.get('groupName');
    
    if (this.selectedOption === 'groupUser') {
      companyNameControl.setValidators([Validators.required, Validators.maxLength(50)]);
    } else {
      companyNameControl.clearValidators();
    }
  
    companyNameControl.updateValueAndValidity();
  }

  preventFirstSpace(event: KeyboardEvent): void {
    CommonFunctions.preventFirstSpaces(event);
  }

  close(): void {
    this.ref.close();
  }

  onSubmit(): void {
    if (this.createUserForm.invalid) {
      this.createUserForm.markAllAsTouched();
      return;
    }
    if (this.createUserForm.valid) {
      
      const updateRequest = {
        driverName: this.createUserForm.value.firstName?.trim(),
        lastName: this.createUserForm.value.lastName?.trim(),
        email: this.createUserForm.value.email,
        mobileNumber: this.createUserForm.value?.phone?.number,
        iso: this.createUserForm.value?.phone?.countryCode,
        countryCode: this.createUserForm.value?.phone?.dialCode,
        groupName: this.createUserForm.value.groupName?.trim(),
        userRole: this.selectedOption ==='parker'? 'driver' : this.selectOption
       };

      if (this.selectedOption === 'groupUser') {
        updateRequest.userRole = this.selectedOption;
        updateRequest.groupName = this.createUserForm.value.groupName?.trim();
        updateRequest['groupUserSpecificField'] = this.createUserForm.value.groupUserSpecificField;
      }
      this.superAdminService.CreateDriverBySuperAdmin(updateRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          
          this.close();
          this.openSuccessModal(res.message);

        }, error: (error) => {
          this.accountErrorMsg = error.error.message;
        }
      })
    }
  }

  openSuccessModal(message) {
    this.dialogControlService.openDialog(DriverCreatedSucessComponent, {
      data: {
        successMessage: message
      },
      styleClass: 'parker-success-model',
    });
  }
    onlyNumberInput(event: KeyboardEvent): void {
    CommonFunctions.onlyNumberInput(event);
  }
}
 